<script setup lang="ts">
import tailwindConfig from "../../../tailwind.config";

withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: tailwindConfig.theme.extend.colors["ppa-dark-blue"],
  },
);
</script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      d="M20 5H10.414L8.707 3.293C8.61426 3.2 8.50406 3.12624 8.38273 3.07596C8.2614 3.02568 8.13134 2.99986 8 3H4C2.897 3 2 3.897 2 5V19C2 20.103 2.897 21 4 21H20C21.103 21 22 20.103 22 19V7C22 5.897 21.103 5 20 5Z"
      :fill="color"
    />
    <rect x="7.66467" y="12.1646" width="8.72941" height="6.23529" rx="1.24706" fill="white" />
    <path
      d="M9.53552 12.4768V10.2944C9.53552 8.91695 10.6522 7.80029 12.0296 7.80029C13.4071 7.80029 14.5238 8.91695 14.5238 10.2944V12.4768"
      stroke="white"
      stroke-width="1.24706"
    />
  </svg>
</template>
